import React, { useState } from "react";
import { ISearchContext, SearchContextProvider, useSearch } from "./SearchContext";

export interface ISortContainerProps {
  sort?: (context: ISearchContext) => React.ReactNode;
}

export const SortContainer: React.FC<ISortContainerProps> = ({
  sort,
}) => {
  const context = useSearch();

  return (
    <>
        {sort && (
          sort(context)
        )}
    </>
  );
};

export default SortContainer;
